import React, { FC, useMemo } from 'react'
import { Button } from '@dasa-health/components-react'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import * as S from './styles'
import { LinkInline } from '@dasa-health/alma-react'
import TopicV2, { TopicItemProps } from '../TopicV2'

const FoldPagePresentationBrandV2: FC = () => {
    const { brand: brand_ } = useAppContext()
    const brand = BrandMapping[brand_.mappingId]

    const items: TopicItemProps[] = useMemo(() => {
        return [
            {
                icon: brand.lpDesignProps?.foldPagePresentationBrand.topics[0].icon
                    ? brand.lpDesignProps?.foldPagePresentationBrand.topics[0].icon
                    : 'HandWithStar',
                text: brand.lpDesignProps?.foldPagePresentationBrand.topics[0].text as string,
                title: brand.lpDesignProps?.foldPagePresentationBrand.topics[0].title as string,
            },
            {
                icon: brand.lpDesignProps?.foldPagePresentationBrand.topics[1].icon
                    ? brand.lpDesignProps?.foldPagePresentationBrand.topics[1].icon
                    : 'ClockV2',
                text: brand.lpDesignProps?.foldPagePresentationBrand.topics[1].text as string,
                title: brand.lpDesignProps?.foldPagePresentationBrand.topics[1].title as string,
            },
            {
                icon: brand.lpDesignProps?.foldPagePresentationBrand.topics[2].icon
                    ? brand.lpDesignProps?.foldPagePresentationBrand.topics[2].icon
                    : 'CalendarV2',
                text: brand.lpDesignProps?.foldPagePresentationBrand.topics[2].text as string,
                title: brand.lpDesignProps?.foldPagePresentationBrand.topics[2].title as string,
            },
        ]
    }, [brand])

    const dataAtributtes = (dataText: string) => ({
        'data-item-position': 'Main Hero',
        'data-current-service': 'Página da Marca',
        'data-item-text': dataText,
    })

    return (
        <div
            style={{
                backgroundImage: `url(${brand.lpDesignProps?.foldPagePresentationBrand.backgroundImage.src})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}
        >
            <S.Container data-testid="page-presentation-testID">
                <S.PrincipalBox>
                    <S.BoxTexts>
                        <S.Title>{brand.lpDesignProps?.foldPagePresentationBrand.title}</S.Title>
                        <S.SubTitle>{brand.lpDesignProps?.foldPagePresentationBrand.subtitle}</S.SubTitle>
                    </S.BoxTexts>
                </S.PrincipalBox>
                <S.ButtonsBox>
                    {brand.vaccine && (
                        <LinkInline
                            href={brand.buttons.mainFold.vaccines}
                            sx={{ textDecoration: 'none' }}
                            target="_self"
                            {...dataAtributtes('Agendar vacinas')}
                        >
                            <Button
                                data-testid="btn-vaccines"
                                style={{
                                    backgroundColor: brand.lpDesignProps?.foldPagePresentationBrand.buttonBackgroundColor,
                                    color: brand.lpDesignProps?.foldPagePresentationBrand.buttonTextColor,
                                }}
                            >
                                Agendar vacina
                            </Button>
                        </LinkInline>
                    )}
                    <LinkInline
                        href={brand.buttons.mainFold.exams}
                        sx={{ textDecoration: 'none' }}
                        target="_self"
                        {...dataAtributtes('Agendar exames')}
                    >
                        <Button
                            data-testid="btn-exams"
                            style={{
                                backgroundColor: brand.lpDesignProps?.foldPagePresentationBrand.buttonBackgroundColor,
                                color: brand.lpDesignProps?.foldPagePresentationBrand.buttonTextColor,
                            }}
                        >
                            Agendar exame
                        </Button>
                    </LinkInline>
                </S.ButtonsBox>

                <S.TopicBox>
                    <TopicV2.Group items={items} />
                </S.TopicBox>
            </S.Container>
        </div>
    )
}

export default FoldPagePresentationBrandV2
